import { Box, Text } from '@fairfashion/design-system'

import { EvidenceDataProps } from './evidence-data.types'

export const EvidenceData = ({ evidence }: EvidenceDataProps) => {
  return (
    <Box width="100%" flex={1} flexWrap="wrap" gap={2}>
      {evidence?.files?.map((file, index) => (
        <a href={file.file} key={`file-${index}`} target="_blank">
          <Box
            gap={2}
            paddingY={1}
            paddingX={2}
            border={{ width: 1, color: 'grey_4' }}
            borderRadius="8px"
            cursor="pointer"
          >
            <Text size="small" color="grey_2">
              {file.name}
            </Text>
          </Box>
        </a>
      ))}
    </Box>
  )
}
